"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

(function () {
  "use strict";

  angular.module("courses").controller("CoursesCtrl", CoursesCtrl);

  function CoursesCtrl($scope, $rootScope, $controller, $timeout, AgGridService, CustomListsService, CustomersService, GroupsService, UsersService, CoursesService, ElearningTemplatesService, ModalService, ApiService, READ_SUMMARY_URL, APP_URL) {
    var _this3 = this;

    var vm = this;
    vm.ctrlName = "CoursesCtrl";
    vm.activeTab = "list";
    vm.statsFilter = { type: [], group: [] };
    vm.statsTypeOptions = [];
    vm.statsGroupOptions = [];

    $controller("ListBaseController", {
      vm: vm,
      $scope: $scope,

      service: CoursesService,
      params: {
        editPage: "courses/course"
      }
    });

    vm.gridEvent = function (value) {
      if (value.type == "exportButton") {
        if (vm.runExport) {
          vm.runExport();
        }
      }
    };

    vm.runExport = function () {
      var sheets = [];

      var maxTab = 1;
      var currentTab = 0;
      while (currentTab < maxTab) {
        var sheet = vm.exportSheet[currentTab]();
        sheets.push(sheet);
        currentTab += 1;
      }

      vm.gridApi[0].exportMultipleSheetsAsExcel({
        data: sheets,
        fileName: "Formations"
      });
    };

    vm.gridReady = function (api, exportSheet, index) {
      if (!vm.gridApi) {
        vm.gridApi = {};
        vm.exportSheet = {};
      }
      vm.gridApi[index] = api;
      vm.exportSheet[index] = exportSheet;
    };

    vm.refresh = function (params) {
      var _this = this;

      console.log("refresh courses", params);

      if (!$rootScope.$selectedCustomerId) {
        return;
      }

      if (params && params.from && params.to) {
        vm.from = params.from;
        vm.to = params.to;
      }

      if (!vm.from || !vm.to) {
        vm.from = moment().subtract(12, "months").startOf("month").toDate();
        vm.to = moment().endOf("month").toDate();
      }

      Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

      var where = { startDate: { $gte: vm.from, $lte: vm.to } };

      vm.elearningMap = {};

      Promise.all([CoursesService.load(null, false, null, where)]).then(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values) {
          var courses, allElearningIds, elearnings, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, e, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, course, traineeNames, groupNames, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, traineeId, trainee, traineeName, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, groupId, groupName, trainerNames, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, trainerId, trainerName, customerTrainerNames, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, customerTrainerId, customerTrainerName;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  courses = values[0];
                  allElearningIds = [].concat(_toConsumableArray(new Set(courses.flatMap(function (c) {
                    return c.elearningIds || [];
                  }).map(function (id) {
                    return id.replace("$", "");
                  }))));

                  if (!(allElearningIds.length > 0)) {
                    _context.next = 26;
                    break;
                  }

                  _context.next = 5;
                  return ElearningTemplatesService.find({
                    filter: {
                      where: { _id: { $in: allElearningIds } },
                      fields: { _id: true, name: true }
                    }
                  });

                case 5:
                  elearnings = _context.sent;

                  if (!(elearnings && !elearnings.error)) {
                    _context.next = 26;
                    break;
                  }

                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context.prev = 10;

                  for (_iterator = elearnings[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    e = _step.value;

                    vm.elearningMap[e._id] = e.name;
                  }
                  _context.next = 18;
                  break;

                case 14:
                  _context.prev = 14;
                  _context.t0 = _context["catch"](10);
                  _didIteratorError = true;
                  _iteratorError = _context.t0;

                case 18:
                  _context.prev = 18;
                  _context.prev = 19;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 21:
                  _context.prev = 21;

                  if (!_didIteratorError) {
                    _context.next = 24;
                    break;
                  }

                  throw _iteratorError;

                case 24:
                  return _context.finish(21);

                case 25:
                  return _context.finish(18);

                case 26:

                  vm.rawData = [];
                  _iteratorNormalCompletion2 = true;
                  _didIteratorError2 = false;
                  _iteratorError2 = undefined;
                  _context.prev = 30;
                  _iterator2 = courses[Symbol.iterator]();

                case 32:
                  if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                    _context.next = 200;
                    break;
                  }

                  course = _step2.value;

                  course.btInfo = {
                    text: '<i class="fa fa-file"></i> Fiche récap.',
                    color: "custom"
                  };

                  // On exclut les formations créés automatiquement suite à un e-learning complété
                  if (!course.linkId) {
                    course.btEdit = {
                      text: '<i class="fa fa-edit"></i> Modifier',
                      color: "custom"
                    };

                    course.btDelete = {
                      text: '<i class="fa fa-trash"></i> Suppr.',
                      color: "custom-danger"
                    };
                  }

                  _context.next = 38;
                  return CustomersService.getNameById(course.customerId);

                case 38:
                  course.customerName = _context.sent;

                  if (!course.forumMode) {
                    _context.next = 44;
                    break;
                  }

                  course.traineeNames = ["Mode Forum"];
                  course.groupNames = [];
                  _context.next = 119;
                  break;

                case 44:
                  if (!course.traineesId) {
                    _context.next = 117;
                    break;
                  }

                  traineeNames = [];
                  groupNames = [];
                  _iteratorNormalCompletion3 = true;
                  _didIteratorError3 = false;
                  _iteratorError3 = undefined;
                  _context.prev = 50;
                  _iterator3 = course.traineesId[Symbol.iterator]();

                case 52:
                  if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                    _context.next = 99;
                    break;
                  }

                  traineeId = _step3.value;
                  _context.next = 56;
                  return UsersService.getById(traineeId);

                case 56:
                  trainee = _context.sent;
                  traineeName = void 0;

                  if (!trainee.error) {
                    _context.next = 63;
                    break;
                  }

                  traineeName = "Collaborateur supprimé";
                  traineeNames.push(traineeName);
                  _context.next = 96;
                  break;

                case 63:
                  _context.next = 65;
                  return UsersService.getName(trainee);

                case 65:
                  traineeName = _context.sent;

                  traineeNames.push(traineeName);

                  if (!trainee.groupsId) {
                    _context.next = 96;
                    break;
                  }

                  _iteratorNormalCompletion4 = true;
                  _didIteratorError4 = false;
                  _iteratorError4 = undefined;
                  _context.prev = 71;
                  _iterator4 = trainee.groupsId[Symbol.iterator]();

                case 73:
                  if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                    _context.next = 82;
                    break;
                  }

                  groupId = _step4.value;
                  _context.next = 77;
                  return GroupsService.getNameById(groupId);

                case 77:
                  groupName = _context.sent;

                  if (!groupNames.includes(groupName)) {
                    groupNames.push(groupName);
                  }

                case 79:
                  _iteratorNormalCompletion4 = true;
                  _context.next = 73;
                  break;

                case 82:
                  _context.next = 88;
                  break;

                case 84:
                  _context.prev = 84;
                  _context.t1 = _context["catch"](71);
                  _didIteratorError4 = true;
                  _iteratorError4 = _context.t1;

                case 88:
                  _context.prev = 88;
                  _context.prev = 89;

                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }

                case 91:
                  _context.prev = 91;

                  if (!_didIteratorError4) {
                    _context.next = 94;
                    break;
                  }

                  throw _iteratorError4;

                case 94:
                  return _context.finish(91);

                case 95:
                  return _context.finish(88);

                case 96:
                  _iteratorNormalCompletion3 = true;
                  _context.next = 52;
                  break;

                case 99:
                  _context.next = 105;
                  break;

                case 101:
                  _context.prev = 101;
                  _context.t2 = _context["catch"](50);
                  _didIteratorError3 = true;
                  _iteratorError3 = _context.t2;

                case 105:
                  _context.prev = 105;
                  _context.prev = 106;

                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }

                case 108:
                  _context.prev = 108;

                  if (!_didIteratorError3) {
                    _context.next = 111;
                    break;
                  }

                  throw _iteratorError3;

                case 111:
                  return _context.finish(108);

                case 112:
                  return _context.finish(105);

                case 113:
                  course.traineeNames = traineeNames;
                  course.groupNames = groupNames;
                  _context.next = 119;
                  break;

                case 117:
                  course.traineeNames = [];
                  course.groupNames = [];

                case 119:
                  if (!course.trainersId) {
                    _context.next = 152;
                    break;
                  }

                  trainerNames = [];
                  _iteratorNormalCompletion5 = true;
                  _didIteratorError5 = false;
                  _iteratorError5 = undefined;
                  _context.prev = 124;
                  _iterator5 = course.trainersId[Symbol.iterator]();

                case 126:
                  if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                    _context.next = 135;
                    break;
                  }

                  trainerId = _step5.value;
                  _context.next = 130;
                  return UsersService.getNameById(trainerId);

                case 130:
                  trainerName = _context.sent;

                  trainerNames.push(trainerName);

                case 132:
                  _iteratorNormalCompletion5 = true;
                  _context.next = 126;
                  break;

                case 135:
                  _context.next = 141;
                  break;

                case 137:
                  _context.prev = 137;
                  _context.t3 = _context["catch"](124);
                  _didIteratorError5 = true;
                  _iteratorError5 = _context.t3;

                case 141:
                  _context.prev = 141;
                  _context.prev = 142;

                  if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                  }

                case 144:
                  _context.prev = 144;

                  if (!_didIteratorError5) {
                    _context.next = 147;
                    break;
                  }

                  throw _iteratorError5;

                case 147:
                  return _context.finish(144);

                case 148:
                  return _context.finish(141);

                case 149:
                  course.trainerNames = trainerNames;
                  _context.next = 153;
                  break;

                case 152:
                  course.trainerNames = [];

                case 153:
                  if (!course.customerTrainersId) {
                    _context.next = 186;
                    break;
                  }

                  customerTrainerNames = [];
                  _iteratorNormalCompletion6 = true;
                  _didIteratorError6 = false;
                  _iteratorError6 = undefined;
                  _context.prev = 158;
                  _iterator6 = course.customerTrainersId[Symbol.iterator]();

                case 160:
                  if (_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done) {
                    _context.next = 169;
                    break;
                  }

                  customerTrainerId = _step6.value;
                  _context.next = 164;
                  return UsersService.getNameById(customerTrainerId);

                case 164:
                  customerTrainerName = _context.sent;

                  customerTrainerNames.push(customerTrainerName);

                case 166:
                  _iteratorNormalCompletion6 = true;
                  _context.next = 160;
                  break;

                case 169:
                  _context.next = 175;
                  break;

                case 171:
                  _context.prev = 171;
                  _context.t4 = _context["catch"](158);
                  _didIteratorError6 = true;
                  _iteratorError6 = _context.t4;

                case 175:
                  _context.prev = 175;
                  _context.prev = 176;

                  if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                  }

                case 178:
                  _context.prev = 178;

                  if (!_didIteratorError6) {
                    _context.next = 181;
                    break;
                  }

                  throw _iteratorError6;

                case 181:
                  return _context.finish(178);

                case 182:
                  return _context.finish(175);

                case 183:
                  course.customerTrainerNames = customerTrainerNames;
                  _context.next = 187;
                  break;

                case 186:
                  course.customerTrainerNames = [];

                case 187:
                  if (!course.duration) {
                    _context.next = 191;
                    break;
                  }

                  _context.next = 190;
                  return CustomListsService.getNameByValue("courseDuration", course.duration);

                case 190:
                  course.durationName = _context.sent;

                case 191:
                  if (!course.type) {
                    _context.next = 195;
                    break;
                  }

                  _context.next = 194;
                  return CustomListsService.getNameByValue("courseType", course.type);

                case 194:
                  course.typeName = _context.sent;

                case 195:

                  course.nbDocs = course.docs ? course.docs.length : 0;

                  vm.rawData.push(course);

                case 197:
                  _iteratorNormalCompletion2 = true;
                  _context.next = 32;
                  break;

                case 200:
                  _context.next = 206;
                  break;

                case 202:
                  _context.prev = 202;
                  _context.t5 = _context["catch"](30);
                  _didIteratorError2 = true;
                  _iteratorError2 = _context.t5;

                case 206:
                  _context.prev = 206;
                  _context.prev = 207;

                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }

                case 209:
                  _context.prev = 209;

                  if (!_didIteratorError2) {
                    _context.next = 212;
                    break;
                  }

                  throw _iteratorError2;

                case 212:
                  return _context.finish(209);

                case 213:
                  return _context.finish(206);

                case 214:

                  vm.statsFilter = { type: [], group: [] };
                  vm.buildFilterOptions(vm.rawData);
                  vm.computeStats(vm.rawData);
                  Notiflix.Loading.remove();
                  $timeout(function () {
                    vm.needToBeUpdate = true;
                  });

                case 219:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this, [[10, 14, 18, 26], [19,, 21, 25], [30, 202, 206, 214], [50, 101, 105, 113], [71, 84, 88, 96], [89,, 91, 95], [106,, 108, 112], [124, 137, 141, 149], [142,, 144, 148], [158, 171, 175, 183], [176,, 178, 182], [207,, 209, 213]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (err) {
        console.error("err", err);
        Notiflix.Loading.remove();
      });
    };

    vm.buildFilterOptions = function (rawData) {
      var types = new Set();
      var groups = new Set();
      var _iteratorNormalCompletion7 = true;
      var _didIteratorError7 = false;
      var _iteratorError7 = undefined;

      try {
        for (var _iterator7 = rawData[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
          var course = _step7.value;

          if (course.typeName) types.add(course.typeName);
          if (course.groupNames) {
            var _iteratorNormalCompletion8 = true;
            var _didIteratorError8 = false;
            var _iteratorError8 = undefined;

            try {
              for (var _iterator8 = course.groupNames[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var g = _step8.value;
                groups.add(g);
              }
            } catch (err) {
              _didIteratorError8 = true;
              _iteratorError8 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                  _iterator8.return();
                }
              } finally {
                if (_didIteratorError8) {
                  throw _iteratorError8;
                }
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError7 = true;
        _iteratorError7 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion7 && _iterator7.return) {
            _iterator7.return();
          }
        } finally {
          if (_didIteratorError7) {
            throw _iteratorError7;
          }
        }
      }

      vm.statsTypeOptions = Array.from(types).sort();
      vm.statsGroupOptions = Array.from(groups).sort();
    };

    vm.applyStatsFilters = function () {
      var filtered = vm.rawData.filter(function (course) {
        if (vm.statsFilter.type.length && !vm.statsFilter.type.includes(course.typeName)) return false;
        if (vm.statsFilter.group.length && (!course.groupNames || !course.groupNames.some(function (g) {
          return vm.statsFilter.group.includes(g);
        }))) return false;
        return true;
      });
      vm.computeStats(filtered);
    };

    vm.resetStatsFilters = function () {
      vm.statsFilter = { type: [], group: [] };
      vm.computeStats(vm.rawData);
    };

    vm.removeStatsFilter = function (key, value) {
      vm.statsFilter[key] = vm.statsFilter[key].filter(function (v) {
        return v !== value;
      });
      vm.applyStatsFilters();
    };

    var chartType = null;
    var chartMonthly = null;

    var CHART_COLORS = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#7f7f7f"];

    vm.renderCharts = function () {
      $timeout(function () {
        if (chartType) {
          chartType.destroy();
          chartType = null;
        }
        if (chartMonthly) {
          chartMonthly.destroy();
          chartMonthly = null;
        }

        if (!vm.stats || vm.stats.total === 0) {
          return;
        }

        chartType = Highcharts.chart("courses-chart-type", {
          colors: CHART_COLORS,
          chart: { type: "pie" },
          title: { text: "Répartition par type" },
          credits: { enabled: false },
          tooltip: {
            pointFormat: "<b>{point.y} formation(s)</b> ({point.percentage:.1f}%)"
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: true,
                format: "<b>{point.name}</b> : {point.y}"
              }
            }
          },
          series: [{
            name: "Formations",
            data: vm.stats.byTypeArray.map(function (r) {
              return { name: r.name, y: r.count };
            })
          }]
        });

        chartMonthly = Highcharts.chart("courses-chart-monthly", {
          chart: { type: "column" },
          title: { text: "Évolution mensuelle" },
          credits: { enabled: false },
          xAxis: {
            categories: vm.stats.byMonthArray.map(function (r) {
              return r.label;
            }),
            crosshair: true
          },
          yAxis: {
            min: 0,
            allowDecimals: false,
            title: { text: "Formations" }
          },
          tooltip: { pointFormat: "<b>{point.y} formation(s)</b>" },
          legend: { enabled: false },
          series: [{
            name: "Formations",
            data: vm.stats.byMonthArray.map(function (r) {
              return r.count;
            }),
            color: "#1f77b4"
          }]
        });
      });
    };

    $scope.$watch(function () {
      return vm.activeTab;
    }, function (newVal) {
      if (newVal === "stats" && vm.stats && vm.stats.total > 0) {
        vm.renderCharts();
      }
    });

    vm.computeStats = function (rawData) {
      var traineeSet = new Set();
      var byType = {};
      var byMonth = {};
      var totalAmount = 0;

      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = rawData[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var course = _step9.value;

          if (course.amount) {
            totalAmount += Number(course.amount) || 0;
          }

          if (!course.forumMode && course.traineesId) {
            var _iteratorNormalCompletion10 = true;
            var _didIteratorError10 = false;
            var _iteratorError10 = undefined;

            try {
              for (var _iterator10 = course.traineesId[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                var id = _step10.value;

                traineeSet.add(id);
              }
            } catch (err) {
              _didIteratorError10 = true;
              _iteratorError10 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                  _iterator10.return();
                }
              } finally {
                if (_didIteratorError10) {
                  throw _iteratorError10;
                }
              }
            }
          }

          var typeName = course.typeName || "Non défini";
          if (!byType[typeName]) {
            byType[typeName] = { count: 0, totalTrainees: 0 };
          }
          byType[typeName].count++;
          if (!course.forumMode && course.traineesId) {
            byType[typeName].totalTrainees += course.traineesId.length;
          }

          var month = moment(course.startDate).format("YYYY-MM");
          if (!byMonth[month]) byMonth[month] = { count: 0, totalTrainees: 0 };
          byMonth[month].count++;
          if (!course.forumMode && course.traineesId) {
            byMonth[month].totalTrainees += course.traineesId.length;
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      vm.stats = {
        total: rawData.length,
        uniqueTrainees: traineeSet.size,
        totalAmount: totalAmount,
        byTypeArray: Object.entries(byType).map(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              name = _ref3[0],
              d = _ref3[1];

          return {
            name: name,
            count: d.count,
            totalTrainees: d.totalTrainees
          };
        }).sort(function (a, b) {
          return b.count - a.count;
        }),
        byMonthArray: Object.entries(byMonth).map(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
              m = _ref5[0],
              d = _ref5[1];

          return {
            label: moment(m, "YYYY-MM").format("MMM YYYY"),
            count: d.count,
            totalTrainees: d.totalTrainees,
            sortKey: m
          };
        }).sort(function (a, b) {
          return a.sortKey < b.sortKey ? -1 : 1;
        })
      };

      if (vm.activeTab === "stats") {
        vm.renderCharts();
      }
    };

    var isAdmin = ["super-admin", "user-admin"].indexOf($rootScope.$user.role) > -1 ? true : false;

    vm.isSuper = ["super-admin", "super-operator"].indexOf($rootScope.$user.role) > -1 ? true : false;

    var writeCourse = isAdmin || vm.isSuper || $rootScope.$user.rights && $rootScope.$user.rights.course && $rootScope.$user.rights.course.write && $rootScope.$user.rights.course.write === true;
    var deleteCourse = isAdmin || vm.isSuper || $rootScope.$user.rights && $rootScope.$user.rights.course && $rootScope.$user.rights.course.delete && $rootScope.$user.rights.course.delete === true;

    if (writeCourse !== true) {
      vm.create = null;
      vm.edit = null;
      vm.importFromExcel = null;
    }

    vm.triggerImport = function () {
      document.getElementById("coursesImportInput").value = "";
      document.getElementById("coursesImportInput").click();
    };

    vm.downloadTemplate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _ref7, _ref8, typeList, durationList, headers, exampleRow, typeInfo, durationInfo, wb, wsData, wsTypes, wsDurations;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return Promise.all([CustomListsService.getSelectArray("courseType"), CustomListsService.getSelectArray("courseDuration")]);

            case 2:
              _ref7 = _context2.sent;
              _ref8 = _slicedToArray(_ref7, 2);
              typeList = _ref8[0];
              durationList = _ref8[1];
              headers = ["Numéro", "Date", "Type", "Durée", "Matricules stagiaires", "Matricules formateurs", "Montant HT", "Commentaires"];
              exampleRow = ["F-2024-001", "15/06/2024", typeList.length ? typeList[0].name : "", durationList.length ? durationList[0].name : "", "MAT001;MAT002", "MAT003", "1200", ""];
              typeInfo = typeList.map(function (t) {
                return t.value + " = " + t.name;
              }).join("\n");
              durationInfo = durationList.map(function (d) {
                return d.value + " = " + d.name;
              }).join("\n");
              wb = XLSX.utils.book_new();
              wsData = XLSX.utils.aoa_to_sheet([headers, exampleRow]);

              wsData["!cols"] = headers.map(function (_, i) {
                return i === 0 ? { wch: 20 } : i <= 3 ? { wch: 18 } : { wch: 30 };
              });
              XLSX.utils.book_append_sheet(wb, wsData, "Formations");

              wsTypes = XLSX.utils.aoa_to_sheet([["Valeur", "Libellé"]].concat(typeList.map(function (t) {
                return [t.value, t.name];
              })));

              wsTypes["!cols"] = [{ wch: 15 }, { wch: 40 }];
              XLSX.utils.book_append_sheet(wb, wsTypes, "Types");

              wsDurations = XLSX.utils.aoa_to_sheet([["Valeur", "Libellé"]].concat(durationList.map(function (d) {
                return [d.value, d.name];
              })));

              wsDurations["!cols"] = [{ wch: 15 }, { wch: 40 }];
              XLSX.utils.book_append_sheet(wb, wsDurations, "Durées");

              XLSX.writeFile(wb, "Import_Formations_modele.xlsx");

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    vm.importFromExcel = function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(files) {
        var reader;
        return regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(!files || !files.length)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                reader = new FileReader();

                reader.onload = function () {
                  var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
                    var _this2 = this;

                    var _ret;

                    return regeneratorRuntime.wrap(function _callee4$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.prev = 0;
                            return _context5.delegateYield( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                              var data, workbook, sheet, rows, _ref11, _ref12, typeList, durationList, allNumbers, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, row, _arr, _i, col, numberToId, users, _iteratorNormalCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, u, created, errors, resolveIds, _loop, i, _ret2, icon, message;

                              return regeneratorRuntime.wrap(function _callee3$(_context4) {
                                while (1) {
                                  switch (_context4.prev = _context4.next) {
                                    case 0:
                                      Notiflix.Loading.standard("Import en cours...");

                                      data = new Uint8Array(e.target.result);
                                      workbook = XLSX.read(data, { type: "array", cellDates: true });
                                      sheet = workbook.Sheets[workbook.SheetNames[0]];
                                      rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });

                                      if (rows.length) {
                                        _context4.next = 9;
                                        break;
                                      }

                                      Notiflix.Loading.remove();
                                      Notiflix.Notify.failure("Le fichier est vide");
                                      return _context4.abrupt("return", {
                                        v: void 0
                                      });

                                    case 9:
                                      _context4.next = 11;
                                      return Promise.all([CustomListsService.getSelectArray("courseType"), CustomListsService.getSelectArray("courseDuration")]);

                                    case 11:
                                      _ref11 = _context4.sent;
                                      _ref12 = _slicedToArray(_ref11, 2);
                                      typeList = _ref12[0];
                                      durationList = _ref12[1];
                                      allNumbers = new Set();
                                      _iteratorNormalCompletion11 = true;
                                      _didIteratorError11 = false;
                                      _iteratorError11 = undefined;
                                      _context4.prev = 19;

                                      for (_iterator11 = rows[Symbol.iterator](); !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                                        row = _step11.value;
                                        _arr = ["Matricules stagiaires", "Matricules formateurs"];

                                        for (_i = 0; _i < _arr.length; _i++) {
                                          col = _arr[_i];

                                          String(row[col] || "").split(";").map(function (x) {
                                            return x.trim();
                                          }).filter(Boolean).forEach(function (n) {
                                            return allNumbers.add(n);
                                          });
                                        }
                                      }

                                      _context4.next = 27;
                                      break;

                                    case 23:
                                      _context4.prev = 23;
                                      _context4.t0 = _context4["catch"](19);
                                      _didIteratorError11 = true;
                                      _iteratorError11 = _context4.t0;

                                    case 27:
                                      _context4.prev = 27;
                                      _context4.prev = 28;

                                      if (!_iteratorNormalCompletion11 && _iterator11.return) {
                                        _iterator11.return();
                                      }

                                    case 30:
                                      _context4.prev = 30;

                                      if (!_didIteratorError11) {
                                        _context4.next = 33;
                                        break;
                                      }

                                      throw _iteratorError11;

                                    case 33:
                                      return _context4.finish(30);

                                    case 34:
                                      return _context4.finish(27);

                                    case 35:
                                      numberToId = {};

                                      if (!(allNumbers.size > 0)) {
                                        _context4.next = 59;
                                        break;
                                      }

                                      _context4.next = 39;
                                      return UsersService.find({
                                        filter: {
                                          where: {
                                            internalNumber: { $in: [].concat(_toConsumableArray(allNumbers)) },
                                            customerId: $rootScope.$selectedCustomerId
                                          },
                                          fields: { _id: true, internalNumber: true }
                                        }
                                      });

                                    case 39:
                                      users = _context4.sent;
                                      _iteratorNormalCompletion12 = true;
                                      _didIteratorError12 = false;
                                      _iteratorError12 = undefined;
                                      _context4.prev = 43;

                                      for (_iterator12 = users[Symbol.iterator](); !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                                        u = _step12.value;

                                        numberToId[u.internalNumber] = u._id;
                                      }
                                      _context4.next = 51;
                                      break;

                                    case 47:
                                      _context4.prev = 47;
                                      _context4.t1 = _context4["catch"](43);
                                      _didIteratorError12 = true;
                                      _iteratorError12 = _context4.t1;

                                    case 51:
                                      _context4.prev = 51;
                                      _context4.prev = 52;

                                      if (!_iteratorNormalCompletion12 && _iterator12.return) {
                                        _iterator12.return();
                                      }

                                    case 54:
                                      _context4.prev = 54;

                                      if (!_didIteratorError12) {
                                        _context4.next = 57;
                                        break;
                                      }

                                      throw _iteratorError12;

                                    case 57:
                                      return _context4.finish(54);

                                    case 58:
                                      return _context4.finish(51);

                                    case 59:
                                      created = 0;
                                      errors = [];

                                      resolveIds = function resolveIds(str, rowNum) {
                                        return String(str || "").split(";").map(function (x) {
                                          return x.trim();
                                        }).filter(Boolean).reduce(function (acc, n) {
                                          var id = numberToId[n];
                                          if (!id) errors.push("Ligne " + rowNum + " : matricule inconnu \"" + n + "\"");else acc.push("$" + id);
                                          return acc;
                                        }, []);
                                      };

                                      _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(i) {
                                        var row, rowNum, name, dateRaw, typeRaw, startDate, parts, typeMatch, durationRaw, duration, durationMatch, course, note;
                                        return regeneratorRuntime.wrap(function _loop$(_context3) {
                                          while (1) {
                                            switch (_context3.prev = _context3.next) {
                                              case 0:
                                                row = rows[i];
                                                rowNum = i + 2;
                                                name = String(row["Numéro"] || "").trim();
                                                dateRaw = row["Date"];
                                                typeRaw = String(row["Type"] || "").trim();

                                                if (name) {
                                                  _context3.next = 8;
                                                  break;
                                                }

                                                errors.push("Ligne " + rowNum + " : num\xE9ro manquant");
                                                return _context3.abrupt("return", "continue");

                                              case 8:
                                                if (dateRaw) {
                                                  _context3.next = 11;
                                                  break;
                                                }

                                                errors.push("Ligne " + rowNum + " : date manquante");
                                                return _context3.abrupt("return", "continue");

                                              case 11:
                                                if (typeRaw) {
                                                  _context3.next = 14;
                                                  break;
                                                }

                                                errors.push("Ligne " + rowNum + " : type manquant");
                                                return _context3.abrupt("return", "continue");

                                              case 14:
                                                startDate = void 0;

                                                if (dateRaw instanceof Date) {
                                                  startDate = dateRaw;
                                                } else {
                                                  parts = String(dateRaw).split("/");

                                                  startDate = parts.length === 3 ? new Date(parts[2], parts[1] - 1, parts[0]) : new Date(dateRaw);
                                                }

                                                if (!isNaN(startDate.getTime())) {
                                                  _context3.next = 19;
                                                  break;
                                                }

                                                errors.push("Ligne " + rowNum + " : date invalide \"" + dateRaw + "\"");
                                                return _context3.abrupt("return", "continue");

                                              case 19:
                                                typeMatch = typeList.find(function (t) {
                                                  return t.value === typeRaw || t.name.toLowerCase() === typeRaw.toLowerCase();
                                                });

                                                if (typeMatch) {
                                                  _context3.next = 23;
                                                  break;
                                                }

                                                errors.push("Ligne " + rowNum + " : type inconnu \"" + typeRaw + "\"");
                                                return _context3.abrupt("return", "continue");

                                              case 23:
                                                durationRaw = String(row["Durée"] || "").trim();
                                                duration = void 0;

                                                if (durationRaw) {
                                                  durationMatch = durationList.find(function (d) {
                                                    return d.value === durationRaw || d.name.toLowerCase() === durationRaw.toLowerCase();
                                                  });

                                                  if (!durationMatch) {
                                                    errors.push("Ligne " + rowNum + " : dur\xE9e inconnue \"" + durationRaw + "\" (ignor\xE9e)");
                                                  } else {
                                                    duration = durationMatch.value;
                                                  }
                                                }

                                                course = {
                                                  name: name,
                                                  startDate: startDate,
                                                  type: typeMatch.value,
                                                  traineesId: resolveIds(row["Matricules stagiaires"], rowNum),
                                                  customerTrainersId: resolveIds(row["Matricules formateurs"], rowNum),
                                                  customerId: $rootScope.$selectedCustomerId
                                                };


                                                if (duration) course.duration = duration;
                                                if (row["Montant HT"] !== "") course.amount = Number(row["Montant HT"]);
                                                note = String(row["Commentaires"] || "").trim();

                                                if (note) course.note = note;

                                                _context3.prev = 31;
                                                _context3.next = 34;
                                                return CoursesService.customPost("createOne", course);

                                              case 34:
                                                created++;
                                                _context3.next = 40;
                                                break;

                                              case 37:
                                                _context3.prev = 37;
                                                _context3.t0 = _context3["catch"](31);

                                                errors.push("Ligne " + rowNum + " : erreur lors de la cr\xE9ation");

                                              case 40:
                                              case "end":
                                                return _context3.stop();
                                            }
                                          }
                                        }, _loop, _this2, [[31, 37]]);
                                      });
                                      i = 0;

                                    case 64:
                                      if (!(i < rows.length)) {
                                        _context4.next = 72;
                                        break;
                                      }

                                      return _context4.delegateYield(_loop(i), "t2", 66);

                                    case 66:
                                      _ret2 = _context4.t2;

                                      if (!(_ret2 === "continue")) {
                                        _context4.next = 69;
                                        break;
                                      }

                                      return _context4.abrupt("continue", 69);

                                    case 69:
                                      i++;
                                      _context4.next = 64;
                                      break;

                                    case 72:

                                      Notiflix.Loading.remove();

                                      icon = created > 0 ? "success" : "warning";
                                      message = created + " formation(s) import\xE9e(s) sur " + rows.length;

                                      if (errors.length) {
                                        message += "\n\nAvertissements :\n" + errors.join("\n");
                                      }

                                      _context4.next = 78;
                                      return swal(message, { icon: icon });

                                    case 78:

                                      if (created > 0) vm.refresh();

                                    case 79:
                                    case "end":
                                      return _context4.stop();
                                  }
                                }
                              }, _callee3, _this2, [[19, 23, 27, 35], [28,, 30, 34], [43, 47, 51, 59], [52,, 54, 58]]);
                            })(), "t0", 2);

                          case 2:
                            _ret = _context5.t0;

                            if (!((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object")) {
                              _context5.next = 5;
                              break;
                            }

                            return _context5.abrupt("return", _ret.v);

                          case 5:
                            _context5.next = 12;
                            break;

                          case 7:
                            _context5.prev = 7;
                            _context5.t1 = _context5["catch"](0);

                            console.error("Import error", _context5.t1);
                            Notiflix.Loading.remove();
                            Notiflix.Notify.failure("Erreur lors de l'import");

                          case 12:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee4, this, [[0, 7]]);
                  }));

                  return function (_x3) {
                    return _ref10.apply(this, arguments);
                  };
                }();

                reader.readAsArrayBuffer(files[0]);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5, this);
      }));

      return function (_x2) {
        return _ref9.apply(this, arguments);
      };
    }();

    vm.delete = function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(row) {
        var deleteCourse;
        return regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return swal({
                  title: "Voulez-vous supprimer la formation " + row.name + " ?",

                  icon: "warning",
                  dangerMode: true,

                  buttons: ["Annuler", "Valider"]
                });

              case 2:
                deleteCourse = _context7.sent;

                if (!deleteCourse) {
                  _context7.next = 7;
                  break;
                }

                console.log("need to delete this course", row);
                _context7.next = 7;
                return CoursesService.deleteById(row._id).then(function () {
                  Notiflix.Notify.success("La suppression a réussi");
                  vm.refresh();
                });

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6, _this3);
      }));

      return function (_x4) {
        return _ref13.apply(this, arguments);
      };
    }();

    vm.displayInfo = function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(course) {
        var _this4 = this;

        var source, forms, mobileModel;
        return regeneratorRuntime.wrap(function _callee8$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                source = READ_SUMMARY_URL + "/";
                forms = [{
                  name: "Informations",
                  filters: ["Fiche"],
                  lines: [{
                    label: "Référence",
                    value: course.name
                  }, {
                    label: "Date",
                    value: course.startDate && moment(course.startDate).format("DD/MM/YYYY")
                  }, {
                    label: "Durée",
                    value: course.durationName
                  }, {
                    label: "Type",
                    value: course.typeName
                  }, {
                    label: "Mode Forum Ouvert",
                    value: course.forumMode ? "Oui" : "Non"
                  }, {
                    label: "Montant en HT",
                    value: course.amount ? course.amount + " €" : ""
                  }, {
                    label: "Stagiaires",
                    value: course.traineeNames.join("<br/>")
                  }, {
                    label: "Groupes des stagiaires",
                    value: course.groupNames.join("<br/>")
                  }, {
                    label: "Formateurs LVR Fleet",
                    value: course.trainerNames.join("<br/>")
                  }, {
                    label: "Formateurs de la société",
                    value: course.customerTrainerNames.join("<br/>")
                  }, {
                    label: "Commentaires",
                    value: course.note
                  }]
                }, {
                  name: "Documents",
                  filters: ["Fiche", "Documents"],
                  lines: [{
                    label: "Documents",
                    value: course.docs
                  }]
                }, {
                  name: "Informations",
                  filters: ["Feuille d'émargement"],
                  lines: [{
                    label: "Référence",
                    value: course.name
                  }, {
                    label: "Date",
                    value: course.startDate && moment(course.startDate).format("DD/MM/YYYY")
                  }, {
                    label: "Durée",
                    value: course.durationName
                  }, {
                    label: "Type",
                    value: course.typeName
                  }]
                }, {
                  name: "Signature du formateur",
                  filters: ["Feuille d'émargement"],
                  isSignatureTable: true,
                  headers: ["N°", "Nom et Prénom", "Signature"],
                  lines: function () {
                    var allTrainers = [].concat(_toConsumableArray(course.trainerNames.map(function (name, index) {
                      return {
                        label: String(index + 1),
                        columns: [{ value: name }, { value: "", isSignature: true }]
                      };
                    })), _toConsumableArray(course.customerTrainerNames.map(function (name, index) {
                      return {
                        label: String(course.trainerNames.length + index + 1),
                        columns: [{ value: name }, { value: "", isSignature: true }]
                      };
                    })));
                    return allTrainers.length > 0 ? allTrainers : [{
                      label: "1",
                      columns: [{ value: "" }, { value: "", isSignature: true }]
                    }];
                  }()
                }, {
                  name: "Liste des stagiaires",
                  filters: ["Feuille d'émargement"],
                  isSignatureTable: true,
                  headers: ["N°", "Nom et Prénom", "Signature"],
                  lines: course.forumMode ? Array.from({ length: 20 }, function (_, index) {
                    return {
                      label: String(index + 1),
                      columns: [{ value: "" }, { value: "", isSignature: true }]
                    };
                  }) : course.traineeNames.map(function (name, index) {
                    return {
                      label: String(index + 1),
                      columns: [{ value: name }, { value: "", isSignature: true }]
                    };
                  })
                }];
                _context9.next = 4;
                return CoursesService.getHistory(course._id);

              case 4:
                course.history = _context9.sent;
                mobileModel = ApiService.getModel("mobile", [], function () {
                  return "";
                });

                if (!(course.elearningIds && !course.linkId)) {
                  _context9.next = 12;
                  break;
                }

                _context9.next = 9;
                return Promise.all((course.elearningIds || []).map(function () {
                  var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(elearningId) {
                    var cleanId, result;
                    return regeneratorRuntime.wrap(function _callee7$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            cleanId = elearningId.replace("$", "");
                            _context8.prev = 1;
                            _context8.next = 4;
                            return mobileModel.customPost("video/" + cleanId + "/tempLink", {});

                          case 4:
                            result = _context8.sent;
                            return _context8.abrupt("return", {
                              url: APP_URL + "?tempId=" + result.tempId,
                              name: vm.elearningMap[cleanId] || "???",
                              filters: ["Fiche", "Feuille d'émargement"]
                            });

                          case 8:
                            _context8.prev = 8;
                            _context8.t0 = _context8["catch"](1);

                            Notiflix.Notify.failure("Impossible de g\xE9n\xE9rer le lien vid\xE9o pour l'e-learning \"" + (vm.elearningMap[cleanId] || cleanId) + "\"");

                          case 11:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee7, _this4, [[1, 8]]);
                  }));

                  return function (_x6) {
                    return _ref15.apply(this, arguments);
                  };
                }()));

              case 9:
                _context9.t0 = _context9.sent;
                _context9.next = 13;
                break;

              case 12:
                _context9.t0 = [];

              case 13:
                course.qrCodes = _context9.t0;


                ModalService.openComponent("custom-iframe", {
                  source: source,
                  title: "Fiche récapitulative",
                  size: "lg",
                  keyboard: false,
                  heightCalculationMethod: "bodyOffset",
                  closeEvent: "mutationObserver",
                  message: {
                    object: course,
                    customerName: course.customerName,
                    titleName: "Formation " + course.name,
                    headerName: "Fiche récapitulative formation",
                    footerName: "Foramtion " + course.name,
                    fileName: "Fiche r\xE9cap - Formation " + course.name,
                    filters: ["Fiche", "Feuille d'émargement", "Documents"],
                    forms: forms,
                    qrCodes: course.qrCodes
                  }
                }).then(function () {
                  console.log("close modal");
                }).catch(function (err) {
                  console.error("err", err);
                });

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee8, this);
      }));

      return function (_x5) {
        return _ref14.apply(this, arguments);
      };
    }();

    vm.columnDefs = [AgGridService.button("btInfo", "Fiche récap.", vm.displayInfo, this, {
      width: 110
    }), AgGridService.date("creationDate", "Date Création"), AgGridService.date("startDate", "Date Formation"), AgGridService.text("durationName", "Durée"), AgGridService.text("name", "Numéro"), AgGridService.text("typeName", "Type"), AgGridService.text("traineeNames", "Stagiaires"), AgGridService.text("groupNames", "Groupes des stagiaires"), AgGridService.text("trainerNames", "Formateurs LVR Fleet"), AgGridService.text("customerTrainerNames", "Formateurs de la société"), AgGridService.number("nbDocs", "Nb docs"), AgGridService.currency("amount", "Montant en HT")];

    if (writeCourse || deleteCourse) {
      var adminColumns = [];

      if (writeCourse) {
        adminColumns.push(AgGridService.button("btEdit", "Modifier", vm.edit, this, {
          width: 90
        }));
      }
      if (deleteCourse && writeCourse) {
        adminColumns.push(AgGridService.button("btDelete", "Suppr.", vm.delete, this, {
          width: 90,
          columnGroupShow: "open"
        }));
      } else if (deleteCourse) {
        adminColumns.push(AgGridService.button("btDelete", "Suppr.", vm.delete, this, {
          width: 90
        }));
      }
      var adminGroup = AgGridService.group("Admin", adminColumns);
      vm.columnDefs.unshift(adminGroup);
    }

    vm.refresh();
  }
})();